import { render, staticRenderFns } from "./TermsAndConditionsPage.nl.vue?vue&type=template&id=1d611596"
import script from "./TermsAndConditionsPage.nl.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsPage.nl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports